export default __webpack_public_path__ + "static/media/Hokky1453453.ff0b4350.gif";